<ion-header [translucent]="true">
  <ion-toolbar>
      <ion-title>Home Page</ion-title>
      <ion-buttons slot="end">
        <ion-title style="cursor: pointer;" size="large" (click)="goToMenu()">Menu</ion-title>
        <!-- <ion-title style="cursor: pointer;" size="large" (click)="goToAdminPage()">Admin</ion-title> -->
        <ion-title style="cursor: pointer;" size="large" (click)="confirmLogout()">Logout</ion-title>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true">

<ion-grid>

  <ion-row>
    <ion-col size = "10">
      <ion-row class="custom-margin">
        <ion-col size="3">
        <!-- This is for select Language -->
        <ion-item class="custom-width">
          <ion-label position="floating">Language</ion-label>
          <!-- <ion-select [disabled]="startClick ||pauseClick " [(ngModel)]="selectedOption" (ionChange)="onOptionChange($event)" interface="popover"> -->
          <ion-select [disabled]="startClick ||pauseClick " [(ngModel)]="selectedOption" (ionChange)="onOptionChange($event)">
              <ion-select-option *ngFor="let option of options" [value]="option.value">
                  {{ option.label }}
              </ion-select-option>
          </ion-select>
        
        </ion-item>
        </ion-col>



        <ion-col size="3">
        <ion-item class="custom-width">
          <ion-label position="floating">Category</ion-label>
              <ion-select [disabled]="startClick ||pauseClick " [(ngModel)]="selectedOptionCategory" (ionChange)="onOptionCategoryChange($event)">
              <!-- <ion-select [disabled]="startClick ||pauseClick " [(ngModel)]="selectedOptionCategory" (ionChange)="onOptionCategoryChange($event)" interface="popover"> -->
                <ion-select-option *ngFor="let option_cat of options_category" [value]="option_cat.value">
                  {{ option_cat.label }}
              </ion-select-option>
              
          </ion-select>
        </ion-item>
        </ion-col>



        

        <!-- <ion-col size="3">
          
        </ion-col> -->


        <ion-col size="3">
          <!-- Right Aligned Search Bar -->
          <ion-item class="custom-width">
            <ion-label position="stacked">Search</ion-label>
            <!-- <ion-input placeholder="Search..."></ion-input> -->
            <ion-input placeholder="Search..." [(ngModel)]="searchTerm" (ionInput)="onSearchChange($event)"></ion-input>
          </ion-item>
          <!-- Overlay to disable the rest of the screen when dropdown is open -->
          <!-- <div *ngIf="filteredTextItems.length > 0" class="overlay"></div> -->

          <!-- <ion-list *ngIf="filteredTextItems.length > 0" class="dropdown-list">
            <ion-item *ngFor="let item of filteredTextItems" (click)="selectTextItem(item)">
              {{ item.Text }}
            </ion-item>
          </ion-list> -->

          <cdk-virtual-scroll-viewport  class="dropdown-list"  *ngIf="filteredTextItems.length > 0" style="height: 200px;" itemSize="40">
              <ion-list>
                <ion-item *cdkVirtualFor="let item of filteredTextItems" (click)="selectTextItem(item)">
                  {{ item.Text }}
                </ion-item>
              </ion-list>
            </cdk-virtual-scroll-viewport>

          
        </ion-col>



        
        <!-- <ion-col size="2"> -->
        <!-- this is for to select Language -->

        <!-- This is for User Details -->
          <!-- Create a card to display user details -->
        <!-- <ion-card>
          <ion-card-header>
            <ion-card-title>User Details</ion-card-title>
          </ion-card-header>

          <ion-card-content>
            <p><strong>Username:</strong>{{userName}}</p>
            <p><strong>Age:</strong>{{userAge}}</p>
            <p><strong>Gender:</strong>{{userGender}}</p>
            <p><strong>Accent:</strong>{{userAccent}}</p>
            <p><strong>Language:</strong>{{userLanguage == 'nl' ?'Dutch':'English'}}</p>
          </ion-card-content>
        </ion-card> -->
      <!-- </ion-col> -->

      </ion-row>
      <ion-row>

      <ion-col size="12">
        <div id="inputbox">
            <div>
              <input type="number" [(ngModel)]="currentIndex" 
                    style="width: 50px;" 
                    (ngModelChange)="showCurrentItem()" 
                    min="1"
                    [attr.max]="textItems.length" style="font-size: 15px;color: #444;background-color: white;"/>

              <span style="margin-left: 5px;">/ {{ textItems.length }}</span>
              
              <!-- Use *ngIf to conditionally display ion-textarea -->
              <ion-textarea *ngIf="textFromServer" 
                            [(ngModel)]="textFromServer" 
                            autoGrow="true" 
                            [readonly]="true" 
                            style="font-size: 30px;"></ion-textarea>

              <ion-button fill="clear" size="small" (click)="updateText()">
                              <ion-icon name="create-outline"></ion-icon>
                            </ion-button>
              
              <ion-textarea *ngIf="countOfTextPerUser" 
                            [(ngModel)]="countOfTextPerUser" 
                            autoGrow="true" 
                            [readonly]="true" 
                            style="font-size: 15px; font-style: italic;"></ion-textarea>
            </div>
            <div id="buttonContainer" class="button-container">
              <ion-row>
    
                <ion-button [ngClass]="{'pulse': isRecording,'red-button': isRecording,}" [disabled]="endClick || startClick|| currentIndex == 0 || currentIndex == null || currentIndex > textItems.length" (click)="startRecording()">{{ isRecording ? 'Recording' : 'Start' }}</ion-button>
                <div [hidden]="pauseClick">
    
                  <ion-button [disabled]="endClick || !startClick" (click)="pauseRecording()">Pause</ion-button>
                </div>
                <div [hidden]="!pauseClick">
                  <ion-button  (click)="continueRecording()" [disabled]="isPlaying" color="danger" >Continue</ion-button>
                </div>
                  
                <ion-button [disabled]="endClick || !startClick" (click)="stopRecording()">Stop</ion-button>
              </ion-row>
              <ion-row>
    
                <ion-button *ngIf="endClick" (click)="saveRecording()">Save</ion-button>
                <ion-button *ngIf="endClick" (click)="cleanRecording()">Redo</ion-button>
                <ion-button *ngIf="endClick" [ngClass]="{'pulse': isPlaying,'red-button': isPlaying,}"  (click)="playRecording()">{{ isPlaying ? 'Playing' : 'Play' }}</ion-button>
                
                
              </ion-row>
            </div>
          
         
        </div>
      
        <div id="buttonContainer" class="button-container">
          
          <ion-row>

           
            <ion-button color = "medium" (click)="showPreviousItem()" [disabled]="currentIndex === 1 || currentIndex === 0 || currentIndex === null"><b>Previous</b></ion-button>
            <!-- <ion-button color="medium" (click)="skipTextFun()" [disabled] = "true"><b>Skip</b></ion-button> -->
            <ion-button color="medium" (click)="showNextItem()" [disabled]="currentIndex >= textItems.length"><b>Next</b></ion-button>
          </ion-row>
        </div>
      </ion-col>
      </ion-row>
    </ion-col>



    <ion-col size="2">
      <div class="button-container">
        <div>
          <ion-card>
              <ion-card-header>
                <ion-card-title>User Details</ion-card-title>
              </ion-card-header>

              <ion-card-content>
                <p><strong>Username:</strong>{{userName}}</p>
                <p><strong>Age:</strong>{{userAge}}</p>
                <p><strong>Gender:</strong>{{userGender}}</p>
                <p><strong>Accent:</strong>{{userAccent}}</p>
                <p><strong>Language:</strong>{{userLanguage == 'nl' ?'Dutch':'English'}}</p>
              </ion-card-content>
          </ion-card>


          <!-- <ion-card (click)="onClickAddText()">
            <ion-card-header>
              <ion-card-title>Add Text</ion-card-title>
            </ion-card-header>
          </ion-card> -->

        <!-- <ion-button expand="full" (click)="openFormModal()">Open Form</ion-button> -->  
          <ion-card class="card-hover-effect" (click)="openFormModal()">
          <!-- <ion-card class="card-hover-effect" (click)="onClickAddSoundText()"> -->
            <ion-card-header style="cursor: pointer;">
              <ion-card-title>Add Texts/Sounds</ion-card-title>
            </ion-card-header>
          </ion-card>
        </div>

      </div>
    </ion-col>
    

  </ion-row>






</ion-grid>
</ion-content>
